module.exports = __webpack_public_path__ + "static/media/path.e27e275f.bin";